module.exports = __webpack_public_path__ + "media/img/illustrations/quote-sign-7074719aab3da515353a62d7417a9c95.svg";